module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate16.6e86b66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate16.png
// module id = 751
// module chunks = 0